import { OrgEmployeeRequestService } from '@api/OrgEmployeeRequestService';
import { useCallback, useState } from 'react';
import { invalidateOrgEmployeeRequestData } from '@stores/orgEmployeeRequestStore';

// TODO: Use useApiCall hook
const useOrgEmployeeRequestComment = (
    orgId: string,
    orgEmployeeId: string | undefined,
): {
    isPostingCommentInProgress: boolean;
    postComment: (requestId: string, comment: string) => Promise<void>;
    error: string | undefined;
} => {
    const [isPosting, setIsPosting] = useState<boolean>(false);
    const [error, setError] = useState<string>();

    const postComment = useCallback(
        async (requestId: string, comment: string) => {
            if (!orgEmployeeId) {
                return;
            }

            setIsPosting(true);
            setError(undefined);

            try {
                await OrgEmployeeRequestService.putOrgEmployeeRequestComment(
                    orgId,
                    orgEmployeeId,
                    requestId,
                    { value: comment },
                );

                // The mutation changed request data — drop cached reads
                invalidateOrgEmployeeRequestData();
            } catch (err: unknown) {
                setError(
                    (err as Error)?.message ||
                        'Something went wrong while posting the comment.',
                );
            } finally {
                setIsPosting(false);
            }
        },
        [orgId, orgEmployeeId],
    );

    return {
        isPostingCommentInProgress: isPosting,
        postComment,
        error,
    };
};

export default useOrgEmployeeRequestComment;
